/* Manchester · Track B port — adapter between custom Manchester variant picker
   (snippets/variant-picker-manchester.liquid, ported from v6 fork) and v8's
   <media-gallery> web component (assets/main.js MediaGallery class).

   v8 MediaGallery expects to find a <variant-picker> element and listen for
   `on:variant:change` events bubbled from it carrying detail.selectedOptions.
   Manchester's custom picker uses div.option-selectors with click handlers in
   color-price-swatches.liquid; it never dispatches that event so the gallery
   never filters media by color (PDP shows every photo of every color).

   This adapter:
   1. Watches the option-selectors block for changes (radio + button clicks).
   2. Reads current selected option labels.
   3. Looks up the matching variant from window.variants_data or product JSON.
   4. Dispatches `on:variant:change` event bubbling up from <product-form> so
      MediaGallery's listener (added on this.section) catches it.

   Drop-in only. Manchester's existing picker handler still runs for ATC + URL
   updates; this adapter only adds the gallery-filtering side effect. */

(function () {
  'use strict';

  function getSelectedOptionsFromDom(form) {
    // Manchester · 2026-05-14 critical — el .option-selectors NO siempre está
    // dentro del form (a veces es sibling, dentro del <variant-picker>).
    // Buscar primero en form, luego escalando hacia arriba.
    var sectionScope = form.closest('.section-main-product, [data-section-type="product"], .shopify-section') || form.parentElement || document;
    var optionSelectors = form.querySelector('.option-selectors')
      || sectionScope.querySelector('.option-selectors')
      || document.querySelector('.option-selectors');
    if (!optionSelectors) return null;

    var selected = [];

    // Try fieldsets first (one per option name)
    var fieldsets = optionSelectors.querySelectorAll('fieldset');
    fieldsets.forEach(function (fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) {
        // value attr OR label text fallback
        var value = checked.value;
        if (!value || value === 'on') {
          var lbl = fs.querySelector('label[for="' + checked.id + '"]');
          if (lbl) value = lbl.textContent.trim();
        }
        selected.push(value);
        return;
      }
      // dropdown fallback
      var sel = fs.querySelector('select');
      if (sel) {
        selected.push(sel.value);
        return;
      }
    });

    return selected.length > 0 ? selected : null;
  }

  function findVariantByOptions(productData, selectedOptions) {
    if (!productData || !productData.variants) return null;
    return productData.variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt === selectedOptions[i];
      });
    }) || null;
  }

  function getProductData(form) {
    // Manchester · 2026-05-14 critical fix — el JSON real del producto está
    // en <script id="product-json-{PRODUCT_ID}"> según Symmetry vanilla.
    // Mis selectores anteriores ([data-product-json] etc) NO matcheaban en
    // este theme — por eso my variant-ID-update fix nunca corría → carrito
    // siempre agregaba el primer color independiente de la selección.
    var productId = form.dataset.productId
      || (form.closest('[data-product-id]') && form.closest('[data-product-id]').dataset.productId)
      || (form.querySelector('input[name="product-id"]') && form.querySelector('input[name="product-id"]').value);

    var candidates = [
      productId ? document.getElementById('product-json-' + productId) : null,
      productId ? document.querySelector('script[type="application/json"][data-product-id="' + productId + '"]') : null,
      form.querySelector('[data-product-json]'),
      form.querySelector('script[type="application/json"][data-product]'),
      document.querySelector('script[id^="product-json-"]'),  // last-resort: any product-json-* script on page
      document.querySelector('[data-product-json]')
    ].filter(Boolean);

    for (var i = 0; i < candidates.length; i++) {
      try {
        var data = JSON.parse(candidates[i].textContent);
        if (data && data.variants && data.variants.length) return data;
      } catch (e) { /* try next */ }
    }

    // fallback to window.theme.product / window.productData
    if (window.theme && window.theme.product && window.theme.product.variants) {
      return window.theme.product;
    }
    if (window.productData && window.productData.variants) return window.productData;
    return null;
  }

  function ensureSectionWrapper(form) {
    return form.closest('product-form') || form.closest('[data-section-type="product"]') || form;
  }

  function dispatchVariantChange(form) {
    var selectedOptions = getSelectedOptionsFromDom(form);
    if (!selectedOptions) return;

    var productData = getProductData(form);
    var variant = findVariantByOptions(productData, selectedOptions);

    // Manchester · 2026-05-14 critical fix — explicitly update the form's
    // variant ID input. Without this, color changes only dispatched a custom
    // event but the form's <input name="id"> kept the FIRST variant's ID,
    // so ATC always added the original color regardless of user selection.
    // Belt-and-suspenders: v8 Section Rendering also updates this on its own
    // via fetch+replace, but if fetch is delayed/cached, we ensure the form
    // is correct synchronously here.
    var sectionWrap = form.closest('.section-main-product, [data-section-type="product"]') || document;
    var targetVariant = variant;

    // Manchester · 2026-05-14 — si no hay match exacto (selección parcial),
    // buscar PRIMER variant DISPONIBLE que matchee las options PARCIALES
    // (ej. usuario cambia color sin re-elegir size → usar primer size del
    // nuevo color). Nunca clear el input[name="id"] → eso causaba ATC POST
    // con id="" → Shopify 422 Unprocessable.
    if (!targetVariant && productData && productData.variants) {
      targetVariant = productData.variants.find(function (v) {
        if (!v.available) return false;
        return v.options.every(function (val, i) {
          // Si la opción no está seleccionada (null/undefined), acepta cualquier valor
          if (selectedOptions[i] == null || selectedOptions[i] === '') return true;
          return val === selectedOptions[i];
        });
      });
    }

    if (targetVariant && targetVariant.id) {
      form.querySelectorAll('input[name="id"]').forEach(function (input) {
        if (String(input.value) !== String(targetVariant.id)) {
          input.value = targetVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      sectionWrap.querySelectorAll('input[name="id"][data-dynamic-variant-content]').forEach(function (input) {
        if (String(input.value) !== String(targetVariant.id)) {
          input.value = targetVariant.id;
        }
      });
    }
    // Si NO encontramos variant alguno (caso extremo: producto sin variants
    // disponibles), dejamos el input como está. La validation Shopify se
    // encargará. NUNCA clearing — eso rompe submits válidos.

    // Manchester · 2026-05-15 — Gray-out tallas agotadas para productos NO
    // dress-shirt (polos, básicos, etc). v6 theme.js tenía esta lógica pero
    // requería variantChanged event que no se dispara en v8. La replico aquí.
    if (productData && productData.variants) {
      updateUnavailableOptions(form, productData, selectedOptions);
      updateCrossColorSuggester(form, productData, selectedOptions);
    }

    // Manchester · 2026-05-15 — ATC button text + disabled sync.
    // v8 nativo expone on:variant:change pero su listener en main.js solo
    // actualiza media gallery, NO el botón ATC. Cuando llegabas via URL
    // a una variant agotada, el botón quedaba stuck en "Agotado" aunque
    // cambiaras a una variant disponible. Ahora actualizamos directo.
    //
    // Manchester · 2026-05-19 — CRITICAL FIX: pasar targetVariant (partial
    // match fallback) en lugar de variant (match exacto). Bug que pudo
    // causar la caída de ventas 18-may:
    // si user cambia color y la talla previa no existe en el nuevo color,
    // findVariantByOptions retorna null → ATC button quedaba con el estado
    // server-rendered ("Agotado" si default variant era OOS) aunque
    // el form ya tenía la variant.id disponible del partial match.
    // Resultado: user no convertía aunque tuviera selección válida.
    syncAtcButton(sectionWrap, targetVariant || variant);

    // Manchester · 2026-05-15 — SKU dinámico (P0.5).
    syncSkuDisplay(sectionWrap, targetVariant || variant);

    var section = ensureSectionWrapper(form);
    section.dispatchEvent(new CustomEvent('on:variant:change', {
      bubbles: true,
      detail: {
        form: form.id ? document.getElementById(form.id) : form,
        variant: variant,
        selectedOptions: selectedOptions
      }
    }));
  }

  /**
   * Manchester · 2026-05-15 — Actualizar el SKU visible cuando cambia variant.
   * El HTML server-side renderea [data-mfg-sku] con el sku del current_variant.
   * Cada vez que el user cambia color/talla, refresheamos al variant matched.
   */
  function syncSkuDisplay(sectionWrap, variant) {
    if (!sectionWrap || !variant) return;
    var sku = variant.sku;
    if (!sku) return;
    var nodes = sectionWrap.querySelectorAll('[data-mfg-sku]');
    nodes.forEach(function (n) {
      if (n.textContent.trim() !== sku) n.textContent = sku;
    });
  }

  /**
   * Manchester · 2026-05-15 — Mantén el botón ATC en sync con el variant
   * actualmente seleccionado. Lee `data-add-to-cart-text` y `data-unavailable-text`
   * de los botones (Symmetry los inyecta server-side con las traducciones
   * correctas) y los aplica según variant.available.
   */
  function syncAtcButton(sectionWrap, variant) {
    if (!sectionWrap) return;
    var buttons = sectionWrap.querySelectorAll('button[name="add"], button.add-to-cart, .product-form__submit, [data-dynamic-variant-content] button[type="submit"]');
    buttons.forEach(function (btn) {
      // Cache base labels in dataset so repeated transitions don't lose them
      if (!btn.dataset.mfgBaseAvail) {
        var availText = btn.dataset.addToCartText
          || btn.dataset.atcText
          || (btn.textContent.trim() && !btn.hasAttribute('disabled') ? btn.textContent.trim() : 'Agregar al carrito');
        btn.dataset.mfgBaseAvail = availText;
      }
      if (!btn.dataset.mfgBaseOos) {
        var oosText = btn.dataset.unavailableText
          || btn.dataset.soldOutText
          || 'Agotado';
        btn.dataset.mfgBaseOos = oosText;
      }

      var hasVariant = !!(variant && variant.id);
      var isAvailable = hasVariant && variant.available;
      var labelTarget = btn.querySelector('.btn-text, .btn__text, span:not([class*="icon"])') || btn;

      if (!hasVariant) {
        // No exact match — leave whatever the partial-match fallback chose;
        // do NOT enable a button that the server has rendered disabled.
        return;
      }

      if (isAvailable) {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('btn--unavailable', 'is-disabled');
        if (labelTarget.textContent.trim() !== btn.dataset.mfgBaseAvail) {
          labelTarget.textContent = btn.dataset.mfgBaseAvail;
        }
      } else {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('btn--unavailable');
        if (labelTarget.textContent.trim() !== btn.dataset.mfgBaseOos) {
          labelTarget.textContent = btn.dataset.mfgBaseOos;
        }
      }
    });
  }

  /**
   * Para cada opt-btn (talla, color, etc), check si existe algún variant
   * disponible con esa opción + las opciones FIJAS de la izquierda. Si no,
   * marca el opt-btn con .is-unavailable → CSS v8 lo grey out + line-through.
   */
  function updateUnavailableOptions(form, productData, selectedOptions) {
    var sectionScope = form.closest('.section-main-product, [data-section-type="product"], .shopify-section') || document;
    var optionSelectors = sectionScope.querySelectorAll('.option-selector[data-option-index]');
    if (!optionSelectors || !optionSelectors.length) return;

    optionSelectors.forEach(function (selector) {
      var optionIdx = parseInt(selector.getAttribute('data-option-index'), 10);
      if (isNaN(optionIdx)) return;

      // Las opciones a la izquierda (ya seleccionadas) son "fixed" para este
      // option group. Las de la derecha son ignoradas (cualquier valor cuenta).
      var fixed = [];
      for (var i = 0; i < optionIdx; i++) fixed.push(selectedOptions[i]);

      var optButtons = selector.querySelectorAll('.opt-btn, .js-option');
      optButtons.forEach(function (btn) {
        var value = btn.value;
        if (value === undefined || value === '') return;

        // ¿Existe algún variant disponible con fixed[] + this value?
        var hasAvailable = productData.variants.some(function (v) {
          if (!v.available) return false;
          for (var i = 0; i < fixed.length; i++) {
            if (fixed[i] != null && fixed[i] !== v.options[i]) return false;
          }
          return v.options[optionIdx] === value;
        });

        btn.classList.toggle('is-unavailable', !hasAvailable);
      });
    });
  }

  /**
   * Manchester · 2026-05-15 — P2 Cross-color suggester.
   * Si la combinación color+talla actual está agotada (o no existe), encuentra
   * OTROS colores con la MISMA talla disponible y renderiza chips clickables
   * justo debajo del último .option-selector. Click en chip → selecciona ese
   * color y dispara variant change (la talla se mantiene gracias a la lógica
   * partial-match en dispatchVariantChange).
   */
  function updateCrossColorSuggester(form, productData, selectedOptions) {
    var sectionScope = form.closest('.section-main-product, [data-section-type="product"], .shopify-section') || document;
    var optionsBlock = sectionScope.querySelector('.option-selectors');
    if (!optionsBlock || !productData || !productData.variants) return;

    // Necesitamos: color (option 0) y talla (option 1+). Solo aplica cuando el
    // producto tiene al menos 2 dimensiones y la talla está seleccionada.
    if (!selectedOptions || selectedOptions.length < 2) {
      removeSuggester(optionsBlock);
      return;
    }
    var currentColor = selectedOptions[0];
    var currentSize = selectedOptions[1];
    if (!currentColor || !currentSize) {
      removeSuggester(optionsBlock);
      return;
    }

    // ¿Existe variant disponible con esta combinación exacta?
    var exactAvailable = productData.variants.some(function (v) {
      return v.available && v.options[0] === currentColor && v.options[1] === currentSize;
    });
    if (exactAvailable) {
      removeSuggester(optionsBlock);
      return;
    }

    // Buscar colores ALT donde la MISMA talla está available
    var altColors = [];
    productData.variants.forEach(function (v) {
      if (!v.available) return;
      if (v.options[1] !== currentSize) return;
      if (v.options[0] === currentColor) return;
      if (altColors.indexOf(v.options[0]) === -1) altColors.push(v.options[0]);
    });

    if (altColors.length === 0) {
      // No hay alternativa cross-color — ofrecer Back-in-Stock signup
      // si la combinación específica color+talla existe como variant agotado.
      var oosVariant = productData.variants.find(function (v) {
        return v.options[0] === currentColor && v.options[1] === currentSize && !v.available;
      });
      if (oosVariant) {
        renderBackInStock(optionsBlock, currentColor, currentSize, oosVariant.id, sectionScope);
      } else {
        removeSuggester(optionsBlock);
      }
      return;
    }

    renderSuggester(optionsBlock, currentSize, altColors, sectionScope);
  }

  /**
   * Manchester · 2026-05-15 — Back-in-Stock signup form.
   * Cuando una combinación específica color+talla está agotada y NO hay
   * alternativa cross-color, mostrar email signup que postea a Klaviyo
   * `Subscribed to Back in Stock` event → dispara el BIS flow cuando
   * inventory_quantity vuelve > 0.
   */
  function renderBackInStock(optionsBlock, color, size, variantId, sectionScope) {
    var box = optionsBlock.querySelector('.mfg-cross-color-suggest');
    if (!box) {
      box = document.createElement('div');
      box.className = 'mfg-cross-color-suggest mfg-cross-color-suggest--bis';
      box.setAttribute('role', 'status');
      box.setAttribute('aria-live', 'polite');
      optionsBlock.appendChild(box);
    } else {
      box.classList.add('mfg-cross-color-suggest--bis');
    }

    var prefillEmail = '';
    try {
      var customerEmailMeta = document.querySelector('meta[name="mfg-customer-email"]');
      if (customerEmailMeta) prefillEmail = customerEmailMeta.getAttribute('content') || '';
    } catch (e) {}

    box.innerHTML =
      '<div class="mfg-cross-color-suggest__title">Agotado en ' + encodeAttr(color) + ' / talla ' + encodeAttr(size) + '.</div>' +
      '<div class="mfg-cross-color-suggest__body">Déjanos tu email y te avisamos cuando vuelva.</div>' +
      '<form class="mfg-bis-form" novalidate>' +
        '<input type="email" name="email" class="mfg-bis-form__email" placeholder="tu@correo.com" required ' +
        (prefillEmail ? 'value="' + encodeAttr(prefillEmail) + '" ' : '') +
        'autocomplete="email" />' +
        '<button type="submit" class="mfg-bis-form__submit">Avísame</button>' +
        '<div class="mfg-bis-form__msg" aria-live="polite"></div>' +
      '</form>';
    box.classList.add('is-active');

    var form = box.querySelector('.mfg-bis-form');
    var msg = box.querySelector('.mfg-bis-form__msg');
    var submitBtn = box.querySelector('.mfg-bis-form__submit');

    if (form && !form.dataset.mfgBisWired) {
      form.dataset.mfgBisWired = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = form.querySelector('input[name="email"]');
        var email = (emailInput.value || '').trim();
        if (!email || email.indexOf('@') < 1) {
          msg.textContent = 'Email inválido.';
          msg.className = 'mfg-bis-form__msg is-error';
          return;
        }
        if (!window.MFG || !window.MFG.klaviyo || !window.MFG.klaviyo.subscribeBackInStock) {
          msg.textContent = 'Servicio no disponible — intenta más tarde.';
          msg.className = 'mfg-bis-form__msg is-error';
          return;
        }
        submitBtn.disabled = true;
        submitBtn.textContent = 'Enviando…';
        window.MFG.klaviyo.subscribeBackInStock(variantId, email)
          .then(function () {
            msg.textContent = '¡Listo! Te avisamos en cuanto vuelva.';
            msg.className = 'mfg-bis-form__msg is-success';
            emailInput.disabled = true;
            submitBtn.textContent = '✓ Suscrito';
            // Track for GA4 + Klaviyo metrics
            if (window.dataLayer) {
              window.dataLayer.push({
                event: 'back_in_stock_signup',
                variant_id: String(variantId),
                color: color,
                size: size
              });
            }
          })
          .catch(function (err) {
            console.warn('[MFG.bis]', err);
            msg.textContent = 'No pudimos registrarte. Intenta de nuevo.';
            msg.className = 'mfg-bis-form__msg is-error';
            submitBtn.disabled = false;
            submitBtn.textContent = 'Avísame';
          });
      });
    }
  }

  function removeSuggester(optionsBlock) {
    var existing = optionsBlock.querySelector('.mfg-cross-color-suggest');
    if (existing) existing.remove();
  }

  function renderSuggester(optionsBlock, currentSize, altColors, sectionScope) {
    var box = optionsBlock.querySelector('.mfg-cross-color-suggest');
    if (!box) {
      box = document.createElement('div');
      box.className = 'mfg-cross-color-suggest';
      box.setAttribute('role', 'status');
      box.setAttribute('aria-live', 'polite');
      optionsBlock.appendChild(box);
    }

    // Lookup color swatch elements to read accurate hex/icon
    var swatchHints = {};
    sectionScope.querySelectorAll('[data-swatch]').forEach(function (sw) {
      var name = sw.getAttribute('data-swatch');
      if (!name) return;
      var key = name.toUpperCase();
      if (swatchHints[key]) return;
      var bg = sw.style.backgroundColor;
      if (!bg) {
        var cs = getComputedStyle(sw);
        bg = cs.backgroundColor;
      }
      swatchHints[key] = bg || 'transparent';
    });

    var chipsHtml = altColors.map(function (color) {
      var key = color.toUpperCase();
      var dotStyle = swatchHints[key] ? 'background:' + swatchHints[key] : 'background:#ccc';
      return '<button type="button" class="mfg-cross-color-chip" data-mfg-suggest-color="' +
        encodeAttr(color) + '">' +
        '<span class="mfg-cross-color-chip__dot" style="' + dotStyle + '"></span>' +
        '<span class="mfg-cross-color-chip__label">' + encodeAttr(color) + '</span>' +
        '</button>';
    }).join('');

    box.innerHTML =
      '<div class="mfg-cross-color-suggest__title">Talla ' + encodeAttr(currentSize) +
      ' agotada en este color.</div>' +
      '<div class="mfg-cross-color-suggest__body">Disponible en:</div>' +
      '<div class="mfg-cross-color-suggest__chips">' + chipsHtml + '</div>';
    box.classList.add('is-active');

    // Wire chip clicks once
    if (!box.dataset.mfgWired) {
      box.dataset.mfgWired = '1';
      box.addEventListener('click', function (e) {
        var chip = e.target.closest('.mfg-cross-color-chip');
        if (!chip) return;
        var targetColor = chip.getAttribute('data-mfg-suggest-color');
        if (!targetColor) return;
        selectColorByValue(sectionScope, targetColor);
      });
    }
  }

  function selectColorByValue(sectionScope, color) {
    // Try the swatch label (which the existing color-price-swatches JS hooks)
    var swatch = Array.from(sectionScope.querySelectorAll('[data-swatch]'))
      .find(function (s) {
        return (s.getAttribute('data-swatch') || '').toUpperCase() === color.toUpperCase();
      });
    if (swatch) { swatch.click(); return; }
    // Fallback: directly toggle the radio for option index 0
    var colorFieldset = sectionScope.querySelector('.option-selector[data-option-index="0"]')
      || sectionScope.querySelector('fieldset.option-selector-fieldset');
    if (!colorFieldset) return;
    var radios = colorFieldset.querySelectorAll('input[type="radio"]');
    radios.forEach(function (r) {
      if ((r.value || '').toUpperCase() === color.toUpperCase()) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function encodeAttr(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  function updateLegendWithSelectedValue(form) {
    var fieldsets = form.querySelectorAll('fieldset.option-selector-fieldset');
    fieldsets.forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend) return;
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (!checked) return;
      var baseLabel = legend.dataset.baseLabel;
      if (!baseLabel) {
        baseLabel = legend.textContent.replace(/\s*:.*$/, '').trim();
        legend.dataset.baseLabel = baseLabel;
      }
      var currentEl = legend.querySelector('.option-value-current');
      if (!currentEl) {
        currentEl = document.createElement('span');
        currentEl.className = 'option-value-current';
        legend.appendChild(currentEl);
      }
      // Manchester · Fashion PDP audit 2026-05-11 — render value in its own span
      // so we can style separator independently. Was: ' · AZUL' single string.
      currentEl.innerHTML = '<span class="option-value-current__sep" aria-hidden="true">·</span>' +
        '<span class="option-value-current__value">' + checked.value + '</span>';
    });
  }

  function attachToForm(form) {
    if (form.dataset.manchesterVariantAdapter === 'attached') return;
    form.dataset.manchesterVariantAdapter = 'attached';

    // Manchester · 2026-05-14 critical — option-selectors puede estar
    // fuera del form (sibling dentro de <variant-picker>). Escalar al section.
    var sectionScope = form.closest('.section-main-product, [data-section-type="product"], .shopify-section') || document;
    var optionSelectors = form.querySelector('.option-selectors')
      || sectionScope.querySelector('.option-selectors');
    if (!optionSelectors) return;

    // Catch radio changes
    optionSelectors.addEventListener('change', function (evt) {
      if (evt.target && (evt.target.matches('input[type="radio"]') || evt.target.matches('select'))) {
        dispatchVariantChange(form);
        updateLegendWithSelectedValue(form);
      }
    });

    // Catch swatch button clicks — including the cps-swatch buttons rendered
    // by color-price-swatches.liquid which update the underlying radio via
    // their own click handler. We listen on the whole product-form not just
    // option-selectors because the swatch grid is rendered alongside it.
    var swatchScope = form.querySelector('.color-price-swatches') ? form : optionSelectors;
    swatchScope.addEventListener('click', function (evt) {
      var btn = evt.target.closest('.cps-swatch, button[data-swatch], [data-option-value], .swatch-item');
      if (btn) {
        setTimeout(function () {
          dispatchVariantChange(form);
          updateLegendWithSelectedValue(form);
        }, 50);
      }
    });

    // Initial dispatch so gallery filters to default-selected color on page load
    setTimeout(function () {
      dispatchVariantChange(form);
      updateLegendWithSelectedValue(form);
    }, 100);
  }

  function init() {
    // Manchester · 2026-05-14 critical fix — incluir .js-product-form que
    // es la clase REAL del cart form en este theme (action=/cart/add).
    // Antes solo matcheaba .js-product (el wrapper, no el form de carrito).
    var forms = document.querySelectorAll(
      'product-form, [data-section-type="product"] form, .product-form, ' +
      'form.js-product-form, form.js-product[action*="/cart/add"]'
    );
    forms.forEach(attachToForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Watch for late-rendered product forms (Quick Buy, AJAX)
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) {
            if (n.matches && n.matches('product-form, .product-form, [data-section-type="product"]')) {
              attachToForm(n.querySelector('form') || n);
            } else if (n.querySelectorAll) {
              n.querySelectorAll('product-form, .product-form').forEach(attachToForm);
            }
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
/* cache-bust 1778811130 */

/* MANCHESTER_CACHE_BUST_1778811279703366900 */
